import React, { useState } from "react"
import Sentry from "../../Common/Sentry"
import { RequestHandler } from "../../Utils/request_handler"
import { CrowdLamp } from "../types"
import Switch from "./CrowdLampSwitch"

const CrowdLampHandler: React.FC<{
  lamp: CrowdLamp
  placeId: number
  available: boolean
  isShelter: boolean
}> = (props) => {
  const [lamp, setLamp] = useState(props.lamp)

  const onClick = async (color: string) => {
    const handler = new RequestHandler(
      `/admin/places/${props.placeId}/crowd_lamps`,
      "POST",
      { color: color }
    )
    const res = await handler.requestWithBody()
    if (res.status !== 200) {
      Sentry.captureMessage(res.body)
      return alert("通信に失敗しました。時間を置いてもう一度お試しください。")
    }
    setLamp(res.body.lamp)
  }

  return (
    <Switch
      lamp={lamp}
      onClick={onClick}
      available={props.available}
      isShelter={props.isShelter}
    />
  )
}

export default CrowdLampHandler
